// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-unused-vars, prettier/prettier */
import * as Types from './generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OutfitterDocumentFieldsFragment = { __typename?: 'OutfitterDocument', id: string, name: string, type: Types.OutfitterDocumentType, outfitter_id: string, external_url?: string | null, listing_ids?: Array<string> | null, pricing_package_ids?: Array<string> | null, created_at: number };

export type OutfitterDocumentsByOutfitterQueryVariables = Types.Exact<{
  outfitterId: Types.Scalars['ID']['input'];
  type?: Types.InputMaybe<Types.OutfitterDocumentType>;
}>;


export type OutfitterDocumentsByOutfitterQuery = { __typename?: 'Query', outfitterDocumentsByOutfitter: Array<{ __typename?: 'OutfitterDocument', id: string, name: string, type: Types.OutfitterDocumentType, outfitter_id: string, external_url?: string | null, listing_ids?: Array<string> | null, pricing_package_ids?: Array<string> | null, created_at: number }> };

export type CreateOutfitterDocumentMutationVariables = Types.Exact<{
  data: Types.CreateOutfitterDocumentInput;
}>;


export type CreateOutfitterDocumentMutation = { __typename?: 'Mutation', createOutfitterDocument: { __typename?: 'OutfitterDocument', id: string, name: string, type: Types.OutfitterDocumentType, outfitter_id: string, external_url?: string | null, listing_ids?: Array<string> | null, pricing_package_ids?: Array<string> | null, created_at: number } };

export type UpdateOutfitterDocumentMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  data: Types.UpdateOutfitterDocumentInput;
}>;


export type UpdateOutfitterDocumentMutation = { __typename?: 'Mutation', updateOutfitterDocument: { __typename?: 'OutfitterDocument', id: string, name: string, type: Types.OutfitterDocumentType, outfitter_id: string, external_url?: string | null, listing_ids?: Array<string> | null, pricing_package_ids?: Array<string> | null, created_at: number } };

export type ArchiveOutfitterDocumentMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type ArchiveOutfitterDocumentMutation = { __typename?: 'Mutation', archiveOutfitterDocument?: any | null };

export const OutfitterDocumentFieldsFragmentDoc = gql`
    fragment OutfitterDocumentFields on OutfitterDocument {
  id
  name
  type
  outfitter_id
  external_url
  listing_ids
  pricing_package_ids
  created_at
}
    `;
export const OutfitterDocumentsByOutfitterDocument = gql`
    query outfitterDocumentsByOutfitter($outfitterId: ID!, $type: OutfitterDocumentType) {
  outfitterDocumentsByOutfitter(outfitterId: $outfitterId, type: $type) {
    ...OutfitterDocumentFields
  }
}
    ${OutfitterDocumentFieldsFragmentDoc}`;

/**
 * __useOutfitterDocumentsByOutfitterQuery__
 *
 * To run a query within a React component, call `useOutfitterDocumentsByOutfitterQuery` and pass it any options that fit your needs.
 * When your component renders, `useOutfitterDocumentsByOutfitterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOutfitterDocumentsByOutfitterQuery({
 *   variables: {
 *      outfitterId: // value for 'outfitterId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useOutfitterDocumentsByOutfitterQuery(baseOptions: Apollo.QueryHookOptions<OutfitterDocumentsByOutfitterQuery, OutfitterDocumentsByOutfitterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OutfitterDocumentsByOutfitterQuery, OutfitterDocumentsByOutfitterQueryVariables>(OutfitterDocumentsByOutfitterDocument, options);
      }
export function useOutfitterDocumentsByOutfitterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OutfitterDocumentsByOutfitterQuery, OutfitterDocumentsByOutfitterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OutfitterDocumentsByOutfitterQuery, OutfitterDocumentsByOutfitterQueryVariables>(OutfitterDocumentsByOutfitterDocument, options);
        }
export type OutfitterDocumentsByOutfitterQueryHookResult = ReturnType<typeof useOutfitterDocumentsByOutfitterQuery>;
export type OutfitterDocumentsByOutfitterLazyQueryHookResult = ReturnType<typeof useOutfitterDocumentsByOutfitterLazyQuery>;
export type OutfitterDocumentsByOutfitterQueryResult = Apollo.QueryResult<OutfitterDocumentsByOutfitterQuery, OutfitterDocumentsByOutfitterQueryVariables>;
export const CreateOutfitterDocumentDocument = gql`
    mutation createOutfitterDocument($data: CreateOutfitterDocumentInput!) {
  createOutfitterDocument(data: $data) {
    ...OutfitterDocumentFields
  }
}
    ${OutfitterDocumentFieldsFragmentDoc}`;
export type CreateOutfitterDocumentMutationFn = Apollo.MutationFunction<CreateOutfitterDocumentMutation, CreateOutfitterDocumentMutationVariables>;

/**
 * __useCreateOutfitterDocumentMutation__
 *
 * To run a mutation, you first call `useCreateOutfitterDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOutfitterDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOutfitterDocumentMutation, { data, loading, error }] = useCreateOutfitterDocumentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOutfitterDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateOutfitterDocumentMutation, CreateOutfitterDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOutfitterDocumentMutation, CreateOutfitterDocumentMutationVariables>(CreateOutfitterDocumentDocument, options);
      }
export type CreateOutfitterDocumentMutationHookResult = ReturnType<typeof useCreateOutfitterDocumentMutation>;
export type CreateOutfitterDocumentMutationResult = Apollo.MutationResult<CreateOutfitterDocumentMutation>;
export type CreateOutfitterDocumentMutationOptions = Apollo.BaseMutationOptions<CreateOutfitterDocumentMutation, CreateOutfitterDocumentMutationVariables>;
export const UpdateOutfitterDocumentDocument = gql`
    mutation updateOutfitterDocument($id: ID!, $data: UpdateOutfitterDocumentInput!) {
  updateOutfitterDocument(id: $id, data: $data) {
    ...OutfitterDocumentFields
  }
}
    ${OutfitterDocumentFieldsFragmentDoc}`;
export type UpdateOutfitterDocumentMutationFn = Apollo.MutationFunction<UpdateOutfitterDocumentMutation, UpdateOutfitterDocumentMutationVariables>;

/**
 * __useUpdateOutfitterDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateOutfitterDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOutfitterDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOutfitterDocumentMutation, { data, loading, error }] = useUpdateOutfitterDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateOutfitterDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOutfitterDocumentMutation, UpdateOutfitterDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOutfitterDocumentMutation, UpdateOutfitterDocumentMutationVariables>(UpdateOutfitterDocumentDocument, options);
      }
export type UpdateOutfitterDocumentMutationHookResult = ReturnType<typeof useUpdateOutfitterDocumentMutation>;
export type UpdateOutfitterDocumentMutationResult = Apollo.MutationResult<UpdateOutfitterDocumentMutation>;
export type UpdateOutfitterDocumentMutationOptions = Apollo.BaseMutationOptions<UpdateOutfitterDocumentMutation, UpdateOutfitterDocumentMutationVariables>;
export const ArchiveOutfitterDocumentDocument = gql`
    mutation archiveOutfitterDocument($id: ID!) {
  archiveOutfitterDocument(id: $id)
}
    `;
export type ArchiveOutfitterDocumentMutationFn = Apollo.MutationFunction<ArchiveOutfitterDocumentMutation, ArchiveOutfitterDocumentMutationVariables>;

/**
 * __useArchiveOutfitterDocumentMutation__
 *
 * To run a mutation, you first call `useArchiveOutfitterDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveOutfitterDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveOutfitterDocumentMutation, { data, loading, error }] = useArchiveOutfitterDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveOutfitterDocumentMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveOutfitterDocumentMutation, ArchiveOutfitterDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveOutfitterDocumentMutation, ArchiveOutfitterDocumentMutationVariables>(ArchiveOutfitterDocumentDocument, options);
      }
export type ArchiveOutfitterDocumentMutationHookResult = ReturnType<typeof useArchiveOutfitterDocumentMutation>;
export type ArchiveOutfitterDocumentMutationResult = Apollo.MutationResult<ArchiveOutfitterDocumentMutation>;
export type ArchiveOutfitterDocumentMutationOptions = Apollo.BaseMutationOptions<ArchiveOutfitterDocumentMutation, ArchiveOutfitterDocumentMutationVariables>;